import { vec2 } from 'gl-matrix';

import { positionAndSizeToBox } from '@canvas/math/box/convert';
import { boxNormalizedLocalToGlobal } from '@canvas/math/box/transform';
import { type Board } from '@canvas/model/board';
import { type Element } from '@canvas/model/element';
import {
  type ConnectorElementData,
  type ElementAnchor,
} from '@canvas/model/elements/connector';

export const toConnectorStartAndEnd = (
  {
    sourceElement,
    sourceAnchor,
    targetElement,
    targetAnchor,
    start,
    end,
  }: ConnectorElementData,
  elements: Board['elements']
) => ({
  start:
    sourceElement && sourceAnchor
      ? toAnchoredPosition(elements[sourceElement] as Element, sourceAnchor)
      : start,
  end:
    targetElement && targetAnchor
      ? toAnchoredPosition(elements[targetElement] as Element, targetAnchor)
      : end,
});

export const toAnchoredPosition = (element: Element, anchor: ElementAnchor) => {
  const bbox = positionAndSizeToBox(element.position, {
    width: element.size.x,
    height: element.size.y,
  });
  return boxNormalizedLocalToGlobal(bbox, vec2.fromValues(anchor.left, anchor.top));
};
